// subscriptionsService.js
// Per-shop SaaS subscription state. Billing itself is hosted by Stripe — this
// wraps the four server endpoints that read state and mint redirect URLs.
//
// The billing customer here is on the Jobvious PLATFORM account, and is NOT the
// Connect payouts account already on `installer_location.stripe_account_id`.
// Two different Stripe customers exist per shop; do not conflate them.

import { HTTPService } from './httpService';

const API = new HTTPService();

/** Plan-picker rows: active + signup_visible, ordered by sort_order. */
export const getPlans = async () => {
    const { data } = await API.get('/subscription-plans');
    return data.data || data;
};

/** One shop's subscription state, plus the plans it may pick from. */
export const getForLocation = async (locationId) => {
    const { data } = await API.get(`/installer-locations/${locationId}/subscription`);
    return data.data || data;
};

/**
 * Hosted Checkout URL for a new subscription.
 * 409 if the shop already has a non-terminal subscription — send them to the Portal.
 */
export const startCheckout = async (locationId, body) => {
    const { data } = await API.post(`/installer-locations/${locationId}/subscription/checkout`, body);
    return data.data || data;
};

/**
 * Hosted Billing Portal URL — payment method + invoice history.
 * 409 if the shop has no billing customer yet (i.e. never subscribed).
 */
export const openPortal = async (locationId, body) => {
    const { data } = await API.post(`/installer-locations/${locationId}/subscription/portal`, body);
    return data.data || data;
};

/**
 * The server's own words for a failure.
 *
 * Reads BOTH `error` and `message`: the task endpoints proved these envelopes
 * are inconsistent across routes, and an empty message is the failure mode we
 * spent a day removing. Never returns empty.
 */
export const subscriptionErrorMessage = (err, fallback = 'Something went wrong. Please try again.') => {
    const data = (err && err.response && err.response.data) || {};
    const raw = data.error || data.message;
    const text = typeof raw === 'string' ? raw.trim() : '';
    return text || fallback;
};

const SubscriptionsAPI = { getPlans, getForLocation, startCheckout, openPortal, subscriptionErrorMessage };
export default SubscriptionsAPI;
